const isPageScroller = (element) => element === document.scrollingElement || element === document.documentElement || element === document.body;

export function getScrollParent(node) {
  for (let parent = node?.parentElement; parent && !isPageScroller(parent); parent = parent.parentElement) {
    const { overflowY } = globalThis.getComputedStyle(parent);
    if (overflowY === 'auto' || overflowY === 'scroll') return parent;
  }
  return null;
}

export function getOuterScrollers(scroller) {
  const outer = [];
  for (let parent = scroller?.parentElement; parent && parent !== document.scrollingElement; parent = parent.parentElement) {
    outer.push({ element: parent, top: parent.scrollTop });
  }
  if (document.scrollingElement) outer.push({ element: document.scrollingElement, top: document.scrollingElement.scrollTop });
  return outer;
}

export function restoreScrollers(scrollers) {
  scrollers.forEach(({ element, top }) => {
    if (element.scrollTop !== top) element.scrollTop = top;
  });
}
